module.exports = __webpack_public_path__ + "static/media/productCategory-01.6238eaa1.png";